import React from "react";

const InformationMsg = () => {
  return (
    <div className="information-msg">
      {" "}
      <img
        src="/assets/images/information-icon.svg"
        alt=""
        className="me-2"
      />{" "}
      This screen is used to track time for Billing and Internal purposes. It is
      not used for Payroll.
    </div>
  );
};

export default InformationMsg;
